import React from 'react'

type RemoveMemberRowProps<T> = {
  member: T
  removeMember: (member: T) => void
}

export function RemoveMemberRow<T>({
  member,
  removeMember,
  children
}: React.PropsWithChildren<RemoveMemberRowProps<T>>) {
  return (
    <div
      className="MembersSelector__member"
      onClick={() => removeMember(member)}
    >
      {children}
    </div>
  )
}
